module.exports = __webpack_public_path__ + "img/thumb-gebakken-kaneeldonuts-uit-de-oven.e9aa1f87.jpg";